import { GetSliceStoreProps, SetSliceStoreProps } from "../useStore";


enum PersistStoreEvents {

}

export type PersistSliceState = {
  user: any,
}

const PersistSlice = (set: SetSliceStoreProps, get: GetSliceStoreProps): PersistSliceState => {


  return {
    user: {} as any,
  };
};

export default PersistSlice;
